import { gql } from "@apollo/client";

export const GET_RECENTLY_VIEWED = gql`
  query recentViewedProducts {
    recentViewedProducts(search: "", pageSize: 5, currentPage: 1) {
      total_count
      currentPage
      pageSize
      totalPages
      items {
        id
        sku
      }
    }
  }
`;

export const ADD_RECENT_VIEWED_PRODUCT = gql`
  mutation addRecentViewedProducts($products: [Int]!) {
    recentViewedProducts(product_ids: $products) {
      message
      total_count
    }
  }
`;

export const GET_RECENTLY_VIEWED_LIST = gql`
  query getRecentlyViewedList($productSkus: [String]!) {
    products(filter: { sku: { in: $productSkus } }) {
      items {
        __typename
        simplebundle
        stock_status
        type_id
        url_key
        flag_text
        flag_color
        url_path
        id
        sku
        uid
        name
        unit
        unit_text
        enable_site_visit
        enable_appliance_site_visit
        small_image {
          url
        }
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        ... on BundleProduct {
          items {
            option_id
            title
            sku
            type
            required
            position
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                uid
                id
                name
                unit_text
                sku
                __typename
                only_x_left_in_stock
                enable_site_visit
                enable_appliance_site_visit
                small_image {
                  url
                }
                price {
                  regularPrice {
                    amount {
                      value
                      currency
                    }
                  }
                }
                __typename
              }
            }
          }
        }
        ... on ConfigurableProduct {
          base_variants {
            attributes {
              code
              value_index
            }
            product {
              uid
              sku
              unit_text
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                }
              }
              small_image {
                url
              }
            }
          }
          variants {
            product {
              small_image {
                url
              }
              name
              unit_text
              only_x_left_in_stock
              enable_site_visit
              enable_appliance_site_visit
              id
              uid
              sku
              stock_status
            }
          }
        }
      }
    }
  }
`;

export default {
  getRecentlyViwedData: GET_RECENTLY_VIEWED,
  addRecentViewedProduct: ADD_RECENT_VIEWED_PRODUCT,
};
